import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./PurchasePrint.css";
import api from "../services/api";

const DeliveryNotePrint = () => {
  const [invoiceData, setInvoiceData] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    fetchPurchases();
  }, []);

  useEffect(() => {
    if (invoiceData) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [invoiceData]);

  const fetchPurchases = async () => {
    try {

      const response = await api.post("/delivery_note_print.php", { id: id });

      if (response.data.head.code === 200) {

        setInvoiceData(response.data.body);
      } else if (response.data.head.code === 606) {
        // No purchases found - set empty array
        setInvoiceData([]);
      } else {
      }
    } catch (err) {
      console.error("Error fetching purchases:", err);
    } finally {
    }
  };

  // useEffect(() => {
  //     const found = dummyInvoices.find(i => i.id === parseInt(id));
  //     if (found) setInvoiceData(found);
  //     setTimeout(() => window.print(), 800);
  // }, [id]);

  if (!invoiceData) return null;

  return (
    <div className="print-page">

      <div className="page-border"></div>

      <div className="print-content">

        {/* HEADER */}
        <div
          className="header-section"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div style={{ width: "33%" }}></div>

          <div
            className="title"
            style={{
              width: "33%",
              textAlign: "center",
              fontWeight: "normal",
            }}
          >
            DELIVERY NOTE
          </div>

          <div
            style={{
              width: "33%",
              textAlign: "right"
            }}
          >
            CELL : {invoiceData.seller_detail.mobile}
          </div>
        </div>

        {/* COMPANY */}
        <div className="company-section" style={{ marginTop: "10px" }}>
          <div className="company-details">
            <h1>{invoiceData.seller_detail.shop_name}</h1>
            <div style={{ fontSize: "16px" }}>{invoiceData.seller_detail.address},
              {invoiceData.seller_detail.city},{" "}
              {invoiceData.seller_detail.state} -{" "}
              {invoiceData.seller_detail.pincode}
            </div>
            <div style={{ fontSize: "16px" }}><b>GSTIN :</b> {invoiceData.seller_detail.gst}</div>
          </div>
        </div>

        {/* INVOICE & CUSTOMER INFO TABLE */}
        <table style={{ width: "100%", marginTop: "15px", borderCollapse: "collapse" }}>
          <tbody>
            <tr>

              {/* LEFT - Customer Info */}
              <td style={{ width: "60%", border: "1px solid black", padding: "5px", verticalAlign: "top" }}>
                <b>To:</b> <br /> <b>{invoiceData.customer_detail.name}</b><br />
                {invoiceData.delivery_address}<br />
                {invoiceData.customer_detail.city} - {invoiceData.customer_detail.pincode}<br />
                <b>GSTIN: {invoiceData.customer_detail.gst}</b>
              </td>

              {/* RIGHT - Invoice Info */}
              {/* <td style={{ width: "40%", border: "1px solid black", padding: "5px", verticalAlign: "top" }}>
                                <div><b>Invoice No:&nbsp;&nbsp;</b> {invoiceData.invoice_id}</div>
                                <div><b>Date:</b> {invoiceData.invoice_date}</div>
                                <div><b>Transport Mode:</b> {invoiceData.transport_mode}</div>
                                <div><b>Vehicle No:</b> {invoiceData.vehicle_no}</div>
                            </td> */}
              <td style={{
                width: "40%",
                border: "1px solid black",
                padding: "5px",
                verticalAlign: "top"
              }}>
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "140px auto",
                  rowGap: "4px"
                }}>
                  <div><b>Delivery Note No</b></div>
                  <div>: <b>{invoiceData.id}</b></div>

                  <div><b>Date</b></div>
                  <div>: {invoiceData.date}</div>

                  <div><b>Transport Mode</b></div>
                  <div>: {invoiceData.transport_mode ?? "On Road"}</div>

                  <div><b>Vehicle No</b></div>
                  <div>: {invoiceData.vehicle_no}</div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>

        <div style={{ display: "flex", flexDirection: "column", minHeight: "65vh" }}>
          {/* ITEMS TABLE */}
          <table className="items-table" style={{ marginTop: "10px" }}>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Description of Goods</th>
                {/* <th className="text-center">HSN</th> */}
                                <th className="text-center">Bundel</th>

                <th className="text-center">Qty</th>
                {/* <th>Rate</th>
                                <th>Amount</th> */}
              </tr>
            </thead>
            <tbody>
              {invoiceData.items.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.item_name}</td>
                  <td>{invoiceData.bundel_count}</td>
                  <td>{item.delivery_qty} {item.unit}</td>
                  {/* <td>{item.rate.toFixed(2)}</td>
                                    <td>₹ {item.total.toFixed(2)}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* PAYMENT & DELIVERY + TOTALS as Table 
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "15px", marginbottom: "0px" }}>
                    <tbody>
                        <tr>
                        
                            <td style={{ width: "55%", border: "1px solid black", padding: "8px", verticalAlign: "top", fontSize: "13px" }}>
                                <div><b>Payment Terms:</b> Cash / Credit</div>
                                <div style={{ marginTop: "5px" }}>
                                    <b>Delivery At:</b><br />
                                    {invoiceData.customer_detail.name}<br />
                                    {invoiceData.customer_detail.address}<br />
                                    {invoiceData.customer_detail.city} - {invoiceData.customer_detail.pincode}
                                </div>
                            </td>

                            <td
                                style={{
                                    width: "45%",
                                    border: "1px solid black",
                                    padding: "8px",
                                    verticalAlign: "top"
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "1fr 1px auto",
                                        columnGap: "8px",
                                        alignItems: "start"
                                    }}
                                >

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            textAlign: "right",
                                            paddingRight: "6px"
                                        }}
                                    >
                                        <div>Goods Value</div>
                                        <div>CGST @ 9%</div>
                                        <div>SGST @ 9%</div>
                                        <div style={{ fontWeight: "bold",fontSize:"18px" }}>Grand Total</div>
                                    </div>


                                    <div style={{ borderLeft: "1px solid black" }} />


                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            textAlign: "right"
                                        }}
                                    >
                                        <div>₹ {invoiceData.goods_value.toFixed(2)}</div>
                                        <div>₹ {invoiceData.cgst.toFixed(2)}</div>
                                        <div>₹ {invoiceData.sgst.toFixed(2)}</div>
                                        <div style={{ fontWeight: "bold",fontSize:"18px" }}>
                                            ₹ {invoiceData.total.toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </td>



                        </tr>
                    </tbody>
                </table>
*/}

        {/* AMOUNT IN WORDS */}
        <div className="d-flex justify-content-between border-top border-dark pt-2 mt-2">
          <div>
            Received by:
          </div>
          <div>
            For {invoiceData.seller_detail.shop_name}
          </div>
        </div>


        {/* BOTTOM SECTION – 3 COLUMN TABLE 
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "25px", textAlign: "left" }}>
                    <tbody>
                        <tr>
                            <td style={{ border: "1px solid black", padding: "10px", width: "37%", fontSize: "8px" }}>
                                <div>
                                    1. Goods once sold cannot be taken back or exchanged<br />
                                    2. Our responsibility ceases as soon as the goods leave our godown<br />
                                    3. All our transactions & invoice are subject to Sivakasi Jurisdiction only.
                                    <br /><br /><br />
                                    <b style={{ textalign: "bottom", margintop: "15px" }} className="mt-5 mb-0">E. & O. E.</b>
                                </div>
                            </td>
                            <td style={{ border: "1px solid black", padding: "10px", width: "20%", verticalAlign: "bottom" }}>
                                <b>Customer Signature</b>
                            </td>
                            <td style={{ border: "1px solid black", padding: "10px", width: "33%", verticalAlign: "middle" }}>
                                <b>For SRI VINAYAGA WIRE INDUSTRIES,</b><br /><br /><br />
                                <b>Authorised Signatory</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
*/}
      </div>
    </div>
  );
};



export default DeliveryNotePrint;
